//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
export default {
  name: 'MmplPartList',
  props: {
    mmplForm: {
      type: Object,
      required: true
    }
  },
  data: function data() {
    return {
      selectionsList: [],
      mtrlTypeGroupOpt: [],
      flag: true,
      mdrlType: [{
        id: 1,
        label: '主材料'
      }, {
        id: 2,
        label: '辅材料'
      }, {
        id: 3,
        label: '其他'
      }]
    };
  },
  created: function created() {
    this.initData();
  },
  methods: {
    initData: function initData() {},
    handleSelectionPart: function handleSelectionPart(selection) {
      this.selectionsList = [];
      this.selectionsList = selection;
      this.$emit('handleSelectionPart', this.selectionsList);
    },
    clearSelection: function clearSelection() {
      this.$refs.multipleTable.clearSelection();
    }
  }
};